import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  Container,
  IconButton,
  CircularProgress,
  Tooltip,
  
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { OptionType } from "dayjs";
import Footer from "../../Footer/Footer";
import StockPopup from "../../Inventory/stockManagement/StockPopup";
import EditStockPopup from "../../Inventory/stockManagement/EditStockPopup";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { ResetTv } from "@mui/icons-material";
import { Autocomplete, TextField } from "@mui/material";

import { enqueueSnackbar, useSnackbar } from "notistack";

import {
  fetchCategories,
  getItemsByCategory,
  getItemTransactionData,
  deleteStockTransaction,
} from "../../Services/inventoryService";
import {
  MSG_CATEGORY_ERROR,
  MSG_ITEM_ERROR,
  MSG_STOCK_DELETE_FAILED,
  MSG_STOCK_DELETED,
  MSG_TRANSACTION_DATA_ERROR,
} from "../../Constants/MessageConstant";
import { LBL_ADD_STOCK, LBL_RESET, LBL_SEARCH, LBL_SEARCHING } from "../../Constants/LabelConstants";

const orgId = localStorage.getItem("orgId") || "";

const StockManagement: React.FC = () => {
  const [categories, setCategories] = useState("");
  const [itemName, setItemName] = useState("");
  const [itemId, setItemId] = useState("");
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const [open, setOpen] = useState(false);

  const [editOpen, setEditOpen] = useState(false);
  const [editData, setEditData] = useState<RowType | null>(null);

  type RowType = {
    id: number;
    transactionId: string;
    date: Date | null;
    category: string;
    itemName: string;
    itemId: string; // 👈 Add this
    stock: number;
    stockOut: number;
    stockIn: number;
    total: number;
  };
  const [rows, setRows] = useState<RowType[]>([]);
  type ItemOption = {
    label: string;
    value: any;
    itemName: string;
    itemId: string;
  };
  const [itemOptions, setItemOptions] = useState<ItemOption[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [originalRows, setOriginalRows] = useState<RowType[]>([]);
  const [isEdited, setIsEdited] = useState(false);

  const handleResetGrid = () => {
    setRows((prevRows) =>
      prevRows.map((row, index) => originalRows[index] || row)
    );
    setIsEdited(false);
  };
  const processRowUpdate = (newRow: RowType, oldRow: RowType) => {
    setIsEdited(true); 
    return newRow; 
  };

  const columns: GridColDef[] = [
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => (
        <>       
          
          <Tooltip title="Edit">
         <IconButton size="small" sx={{ padding: 0.5 }}
            onClick={() => {
              setEditData(params.row);
              setEditOpen(true);
            }}       
          ><EditIcon fontSize="small"  />
          </IconButton>
          </Tooltip>  
           <Tooltip title="Delete" arrow>
          <IconButton
           onClick={() => handleDelete(params.row)}
            size="small"
            color="error"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
          </Tooltip>

        </>
      ),
    },
    { field: "id", headerName: "SN", width: 70 },
    { field: "category", headerName: "Category", editable: false, width: 150 },
    { field: "itemName", headerName: "Item Name", editable: false, width: 150 },
    // {
    //   field: "category",
    //   headerName: "Category",
    //   width: 250, // Wider column
    //   editable: true,
    //   renderEditCell: (params) => (
    //     <Box sx={{ width: "100%" }}>
    //       <Autocomplete
    //         fullWidth
    //         options={categoryOptions}
    //         value={
    //           categoryOptions.find((opt) => opt.label === params.value) || null
    //         }
    //         onChange={(event, newValue) => {
    //           params.api.setEditCellValue(
    //             {
    //               id: params.id,
    //               field: params.field,
    //               value: newValue?.label || "",
    //             },
    //             event
    //           );
    //         }}
    //         isOptionEqualToValue={(option, value) =>
    //           option.label === value.label
    //         }
    //         getOptionLabel={(option) => option.label}
    //         renderInput={(inputParams) => (
    //           <TextField
    //             {...inputParams}
    //             variant="standard"
    //             placeholder="Search Category..."
    //             sx={{ minWidth: 240 }} // Ensures wider dropdown
    //           />
    //         )}
    //       />
    //     </Box>
    //   ),
    // },
    // {
    //   field: "itemName",
    //   headerName: "Item Name",
    //   width: 280, // Wider column
    //   editable: true,
    //   renderEditCell: (params) => (
    //     <Box sx={{ width: "100%" }}>
    //       <Autocomplete
    //         fullWidth
    //         options={itemOptions}
    //         value={
    //           itemOptions.find((opt) => opt.itemName === params.value) || null
    //         }
    //         onChange={(event, newValue) => {
    //           params.api.setEditCellValue(
    //             {
    //               id: params.id,
    //               field: params.field,
    //               value: newValue?.itemName || "",
    //             },
    //             event
    //           );
    //         }}
    //         isOptionEqualToValue={(option, value) =>
    //           option.itemName === value.itemName
    //         }
    //         getOptionLabel={(option) => option.label}
    //         renderInput={(inputParams) => (
    //           <TextField
    //             {...inputParams}
    //             variant="standard"
    //             placeholder="Search Item..."
    //             sx={{ minWidth: 240 }}
    //           />
    //         )}
    //       />
    //     </Box>
    //   ),
    // },

    {
      field: "date",
      headerName: "Date",
      editable: false,
      width: 150,
      type: "date",
    },
    { field: "stock", headerName: "Stock", editable: false, width: 130 },
    { field: "stockOut", headerName: "Stock Out", editable: false, width: 120 },
    { field: "stockIn", headerName: "Stock In", editable: false, width: 120 },
    { field: "total", headerName: "Total", width: 100 },
  ];

  useEffect(() => {
    const getCategories = async () => {
      try {
        const categories = await fetchCategories(orgId);
        const formattedOptions = categories.map((category: any) => ({
          id: category.categoryId,
          label: category.categoryName,
        }));
        setCategoryOptions(formattedOptions);
      } catch (error) {
        console.error(MSG_CATEGORY_ERROR, error);
      }
    };
    getCategories();
  }, []);

  useEffect(() => {
    const getItems = async () => {
      if (!selectedCategoryId) return;
      try {
        const items = await getItemsByCategory(orgId, selectedCategoryId);
        const options = items.map((item: any) => {
          const shortDesc = item.description
            ? " - " +
              item.description.split(" ").slice(0, 5).join(" ") +
              (item.description.split(" ").length > 5 ? "..." : "")
            : "";
          return {
            label: `${item.itemName}${shortDesc}`,
            value: item.itemId,
            itemName: item.itemName,
            itemId: item.itemId,
            item: item,
          };
        });

        setItemOptions(options);
      } catch (err) {
        console.error(MSG_ITEM_ERROR, err);
      }
    };

    getItems();
  }, [selectedCategoryId]);

  useEffect(() => {
    setItemName("");
  }, [selectedCategoryId]);

  const handleSearch = async () => {
    try {
      if (!selectedCategoryId) {
        enqueueSnackbar("Please select a category.", { variant: "warning" });
        return;
      }
      setLoading(true);
      const fromDateStr = dateFrom
        ? dateFrom.toISOString().split("T")[0]
        : undefined;
      const toDateStr = dateTo ? dateTo.toISOString().split("T")[0] : undefined;

      const itemsArray = await getItemTransactionData(
        orgId,
        selectedCategoryId,
        itemId || undefined,
        fromDateStr,
        toDateStr
      );
      const formattedRows = itemsArray.map((item: any, index: number) => ({
        id: index + 1,
        transactionId: item.transactionId ?? item.id ?? "",
        date: item.date?._seconds ? new Date(item.date._seconds * 1000) : null,
        category:
          item.categoryName ??
          categoryOptions.find((c) => c.id === selectedCategoryId)?.label ??
          "Unknown",
        itemName: item.itemName ?? "",
        itemId: item.itemId ?? "",
        stock: item.stock ?? 0,
        stockOut: item.stockOut ?? 0,
        stockIn: item.stockIn ?? 0,
        total: item.totalStock ?? item.total ?? 0,
      }));
      setRows(formattedRows);
      setOriginalRows(formattedRows);
      setIsEdited(false);
    } catch (err) {
      console.error(MSG_TRANSACTION_DATA_ERROR, err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (row: RowType) => {
    const confirm = window.confirm(
      `Are you sure you want to delete stock entry for "${
        row.itemName
      }" on ${row.date?.toLocaleDateString()}?`
    );
    if (!confirm) return;

    try {
      await deleteStockTransaction(
        orgId,
        row.itemId,
        row.transactionId,
        "LM",
        "12:12"
      ); // ✅ Use transactionId

      const updatedRows = rows.filter(
        (r) => r.transactionId !== row.transactionId
      );
      setRows(updatedRows);
      setOriginalRows(updatedRows);

      enqueueSnackbar(MSG_STOCK_DELETED, { variant: "success" });
    } catch (error) {
      console.error("Delete error:", error);
      enqueueSnackbar(MSG_STOCK_DELETE_FAILED, { variant: "error" });
    }
  };
  const handleReset = () => {
    setSelectedCategoryId("");
    setItemId("");
    setItemName("");
    setDateFrom(null);
    setDateTo(null);
    setRows([]);
  };
  return (
    <>
      <div className="page-location">
        <span>Inventory &gt; Manage Stock</span>
      </div>

      <Container maxWidth="lg" sx={{ padding: 1 }}>
        <Box sx={{ display: "flex", right: 60, justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={() => setOpen(true)}
            startIcon={<AddIcon />}
          >
            {LBL_ADD_STOCK}
          </Button>
        </Box>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box p={2}>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  options={categoryOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    categoryOptions.find(
                      (opt) => opt.id === selectedCategoryId
                    ) || null
                  }
                  onChange={(e, newValue) =>
                    setSelectedCategoryId(newValue?.id || "")
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Category" fullWidth />
                  )}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Autocomplete
                  options={itemOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    itemOptions.find((opt) => opt.itemId === itemId) || null
                  }
                  onChange={(e, newValue) => {
                    setItemId(newValue?.itemId || "");
                    setItemName(newValue?.itemName || "");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Item Name" fullWidth />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DatePicker
                  label="Date From"
                  minDate={new Date(0)}
                  maxDate={new Date()}
                  value={dateFrom}
                  onChange={(newValue: Date | null) => setDateFrom(newValue)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      // sx: { maxWidth: { xs: "50vw", md: "100%" } },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DatePicker
                  label="Date To"
                  minDate={new Date(0)}
                  maxDate={new Date()}
                  value={dateTo}
                  onChange={(newValue: Date | null) => setDateTo(newValue)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      // sx: { maxWidth: { xs: "50vw", md: "100%" } },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 2,
                    gap: 2,
                  }}
                >
                  {/* <Button
                    variant="contained"
                    onClick={handleSearch}
                    startIcon={<SearchIcon />}
                  >
                    Search
                  </Button> */}

                  <Button
                    variant="contained"
                    onClick={handleSearch}
                    startIcon={
                      loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <SearchIcon />
                      )
                    }
                    disabled={loading}
                  >
                    {loading ? LBL_SEARCHING : LBL_SEARCH}
                  </Button>
                  {/* <StockPopup open={open} setOpen={setOpen} /> */}
                  <StockPopup
                    open={open}
                    setOpen={setOpen}
                    categoryOptions={categoryOptions}
                  />
                  {/* Edit Stock popup */}
                  <EditStockPopup
                    open={editOpen}
                    setOpen={setEditOpen}
                    //categoryOptions={categoryOptions}
                    editData={editData}
                    onUpdate={handleSearch}
                  />
                  <Button
                    variant="outlined"
                    onClick={handleReset}
                    startIcon={<ResetTv />}
                  >
                    {LBL_RESET}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              height: { xs: 300, sm: 400, md: 500 },
              width: "100%",
              maxWidth: { xs: "80vw", md: "100%" },
              overflowX: "auto",
              overflowY: "auto",
            }}
          >
            <DataGrid
              rows={rows}
              columns={columns.map((col) => ({
                ...col,
                headerClassName: "super-app-theme--header",
                headerStyle: { fontWeight: "bold" },
                //editable: true,
              }))}
              processRowUpdate={processRowUpdate} // ✅ Replace onCellEditCommit
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 10 },
                },
              }}
              pageSizeOptions={[10, 20, 50]}
              autoHeight
              loading={loading}
              sx={{
                "& .super-app-theme--header": {
                  fontWeight: "bold",
                },
              }}
            />
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 2,
              gap: 2,
            }}
          >
            <Button
              variant="outlined"
              disabled={!isEdited} // 🔹 Disable until edited
              onClick={() => alert("Implement update logic here")}
              startIcon={<EditIcon />}
            >
              Update Grid
            </Button>
            <Button
              variant="outlined"
              disabled={!isEdited} // 🔹 Disable until edited
              onClick={handleResetGrid}
              startIcon={<ResetTv />}
            >
              Reset Grid
            </Button>
          </Box> */}
        </LocalizationProvider>
      </Container>
      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
          mt: 10,
        }}
      >
        <Footer />
      </Box>
    </>
  );
};
export default StockManagement;
